module.exports = __webpack_public_path__ + "static/media/Home1.d7f46dc8.png";